import { useSearchParams } from 'react-router-dom';

// Fixed-vocabulary error codes from the backend OAuth callback. Anything
// outside this map falls through to a generic message — never echo the raw
// query param into the DOM.
const ERR_COPY: Record<string, string> = {
  oauth_state: 'Sign-in expired before it could complete. Try again.',
  oauth_failed: 'Google sign-in failed. Please try again.',
  not_allowed: 'This Google account is not permitted to sign in.'
};

export default function Login() {
  const [params] = useSearchParams();
  const err = params.get('err');
  const errMsg = err ? ERR_COPY[err] ?? 'Sign-in failed.' : null;

  return (
    <div className="grid min-h-dvh place-items-center bg-[var(--bg-sunken)] p-4">
      <div className="w-[360px] max-w-full rounded-xl border border-[var(--border)] bg-[var(--bg)] p-8 shadow-md">
        <h1 className="mb-1 text-2xl font-semibold">Rialto</h1>
        <p className="mb-6 text-[var(--text-muted)]">Sign in to continue.</p>
        {errMsg && (
          <div
            role="alert"
            className="mb-4 rounded-md border border-[var(--today-fg)] bg-[var(--today-bg)] px-3 py-2 text-[0.85rem]"
            style={{ color: 'var(--today-fg)' }}
          >
            {errMsg}
          </div>
        )}
        <a
          href="/auth/google"
          className="block w-full rounded-lg bg-[var(--accent)] py-3 text-center font-medium text-[var(--accent-fg)] no-underline"
        >
          Sign in with Google
        </a>
      </div>
    </div>
  );
}
